/* eslint-disable no-restricted-imports */
import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import * as actions from "./../../../_redux/schDocuments/schdocumentsActions";
import { useSchDocumentsUIContext } from "../SchDocumentsUIContext";

export function SchDocumentDeleteDialog({ id, show, onHide }) {
  // SchDocuments UI Context
  const schDocumentsUIContext = useSchDocumentsUIContext();
  const schDocumentsUIProps = useMemo(() => {
    return {
      setIds: schDocumentsUIContext.setIds,
      queryParams: schDocumentsUIContext.queryParams,
    };
  }, [schDocumentsUIContext]);

  // SchDocuments Redux state
  const dispatch = useDispatch();
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.schDocuments.actionsLoading }),
    shallowEqual
  );

  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  const deleteSchDocument = () => {
    // server request for deleting schDocument by id
    dispatch(actions.deleteSchDocument(id)).then(() => {
      // refresh list after deletion
      dispatch(actions.fetchSchDocuments(schDocumentsUIProps.queryParams));
      // clear selections list
      schDocumentsUIProps.setIds([]);
      // closing delete modal
      onHide();
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {isLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          SchDocument Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>Are you sure to permanently delete this schDocument?</span>
        )}
        {isLoading && <span>SchDocument is deleting...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={deleteSchDocument}
            className="btn btn-delete btn-elevate"
          >
            Delete
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
